import { getCountryCallingCode } from 'react-phone-number-input';

/**
 * Safely retrieve the calling code for a country, returning a fallback when the
 * country code is invalid or unsupported by react-phone-number-input.
 *
 * @param {string} country - ISO country code (e.g. 'MX', 'US').
 * @param {string} [fallback=''] - Value to return when lookup fails.
 * @returns {string} The country calling code or the fallback.
 */
const getSafeCountryCallingCode = (country, fallback = '') => {
  try {
    return getCountryCallingCode(country) || fallback;
  } catch (error) {
    return fallback;
  }
};

export default getSafeCountryCallingCode;
